<template>
  <v-main>
    <audio id="reg-sound" ref="regSound"><source src="./../../../assets/snd/effect1.wav" type="audio/wav"></audio>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="mt-n3">{{$t("Registrations")}}</h1>
        </v-flex>

        <v-flex xs12 class="mb-4">
          <v-layout row wrap>
          <v-btn v-if="!wheelLoaderDisableButtons" class="ml-1 mr-4 mt-4" :to="{name: 'create-wheel-loader-registration', params: {id: null, pendingVehicles: pendingVehicles}}" color="primary">
            <v-icon left>add</v-icon>
            {{$t("New")}}
          </v-btn>
          <v-checkbox v-if="!playSound" class="mt-5 ml-2 mr-2" v-model="playSound" @change="soundOnce()" :off-icon="'notifications_active'" ></v-checkbox>
          <v-flex grow></v-flex>
          <v-flex shrink><v-select v-if="localZplPrint" class="ml-2" style="max-width:90px" hide-details="true" :items="printers" v-model="printerNo" label="Printer" @change="printerChanged" :item-text="item => item.no" :no-data-text="ct.NoDataAvailable"></v-select></v-flex>
          <v-flex shrink><v-select class="ml-2" hide-details="true" :items="plants" v-model="plantName" @change="plantChanged" :label="$t('Plant')"></v-select></v-flex>
          <v-flex shrink><v-select class="ml-2" hide-details="true" :items="facilitiesDisplay" v-model="facilityDisplay" @change="facilityChanged" :label="$t('Facility')"></v-select></v-flex>
          </v-layout>
        </v-flex>

        <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
        <v-flex xs12 v-else>
          <div v-if="registrations != null && registrations.length == 0" class="mt-4" style="text-align: center">{{$t("No unfinished registrations found")}}</div>
          <div v-else v-for="wlReg in orderedRegistrations" :key="wlReg.id">
            <v-card raised class="mb-4" v-if="wlReg.FinishedBy == null && !wlReg.Registration.Completed">
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-layout v-if="!isHide('Vehicle')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4 class="font-weight-bold">{{$t("Vehicle")}}:</v-flex>
                    <v-flex d-flex xs8 class="font-weight-bold" >{{wlReg.Registration.VehicleNo}} - {{wlReg.Registration.VehicleLicensePlateNo}}</v-flex>
                    <v-flex v-if="VehicleNameDisplay" d-flex xs4 class="font-weight-bold">{{$t("")}}</v-flex>
                    <v-flex v-if="VehicleNameDisplay" d-flex xs8 class="font-weight-bold text-xs-right" style="text-align: right;">{{wlReg.Registration.VehicleName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Article')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Article")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{wlReg.Registration.ArticleNo}} - {{wlReg.Registration.ArticleName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Carrier')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Carrier")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{wlReg.Registration.CarrierNo}} - {{wlReg.Registration.CarrierName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Customer')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Customer")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{getCustomerStr(wlReg)}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Agreement')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Agreement")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{wlReg.Registration.AgreementNo}} - {{wlReg.Registration.AgreementName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Delivery')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Delivery")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{wlReg.Registration.DeliveryNo}} - {{wlReg.Registration.DeliveryName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('RequisitionNo1')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("RequisitionNo1")}}:</v-flex>
                    <v-flex d-flex xs8>{{wlReg.Registration.RequisitionNo1}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('RequisitionNo2')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("RequisitionNo2")}}:</v-flex>
                    <v-flex d-flex xs8>{{wlReg.Registration.RequisitionNo2}}</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md6>
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("ScanXRegNo")}}:</v-flex>
                    <v-flex d-flex xs8>{{wlReg.Registration.ScanXRegNo}}</v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Weight")}}:</v-flex>
                    <v-flex d-flex xs8>{{getWeightStr(wlReg)}}</v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("DateFirst")}}:</v-flex>
                    <v-flex d-flex xs8>{{getDate(wlReg.Registration.DateFirst)}}</v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("RegistrationNo")}}:</v-flex>
                    <v-flex d-flex xs8>{{wlReg.Registration.No}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Plant')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Plant")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{wlReg.Registration.PlantNo}} - {{wlReg.Registration.PlantName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Facility')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Facility")}}:</v-flex>
                    <v-flex d-flex xs8>{{wlReg.Registration.Facility}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Comment')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Comment")}}:</v-flex>
                    <v-flex d-flex xs8>{{wlReg.Registration.Comment1}}</v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
                <v-card-actions style="padding: 0px 0px 0px 0px" v-if="wlReg.FinishedBy == null && !wlReg.Registration.Completed">
                  <v-flex xs12 text-right>
                    <v-btn class="mr-1 mb-1" @click="onFinishClick(wlReg)" color="success">
                      {{$t("Finish")}}
                    </v-btn>
                    <v-btn v-if="!wheelLoaderDisableButtons" class="mr-1 mb-1" :to="{name: 'edit-wheel-loader-registration', params: {id: wlReg.Id, pendingVehicles: []}}" color="primary">
                      {{$t("Edit")}}
                    </v-btn>
                    <v-btn class="mr-1 mb-1" :to="{name: 'add-wheel-loader-weight', params: {id: wlReg.Id}}" :color="'primary'">
                      {{$t("Set weight")}}{{wlReg.Comment ? ' (' + wlReg.Comment + ')' : ''}}
                    </v-btn>
                  </v-flex>
              </v-card-actions>
            </v-card>
          </div>

        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <div v-if="loading"></div>
        <v-flex xs12 v-else>
          <h2 class="mb-4 mt-4">{{$t("Recent Registrations")}}</h2>
        </v-flex>

        <div v-if="loading"></div>
        <v-flex xs12 v-else>
          <div v-if="registrations != null && registrations.length == 0" class="mt-4" style="text-align: center">{{$t("No recent registrations found")}}</div>
          <div v-else v-for="wlReg in orderedRegistrationsReverse" :key="wlReg.id">
            <v-card raised class="mb-4" v-if="wlReg.FinishedBy != null || wlReg.Registration.Completed">
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-layout v-if="!isHide('Vehicle')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4 class="font-weight-bold">{{$t("Vehicle")}}:</v-flex>
                    <v-flex d-flex xs8 class="font-weight-bold" >{{wlReg.Registration.VehicleNo}} - {{wlReg.Registration.VehicleLicensePlateNo}}</v-flex>
                    <v-flex v-if="VehicleNameDisplay" d-flex xs4 class="font-weight-bold">{{$t("")}}</v-flex>
                    <v-flex v-if="VehicleNameDisplay" d-flex xs8 class="font-weight-bold" >{{wlReg.Registration.VehicleName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Article')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Article")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{wlReg.Registration.ArticleNo}} - {{wlReg.Registration.ArticleName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Carrier')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Carrier")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{wlReg.Registration.CarrierNo}} - {{wlReg.Registration.CarrierName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Customer')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Customer")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{getCustomerStr(wlReg)}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Agreement')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Agreement")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{wlReg.Registration.AgreementNo}} - {{wlReg.Registration.AgreementName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Delivery')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Delivery")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{wlReg.Registration.DeliveryNo}} - {{wlReg.Registration.DeliveryName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('RequisitionNo1')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("RequisitionNo1")}}:</v-flex>
                    <v-flex d-flex xs8>{{wlReg.Registration.RequisitionNo1}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('RequisitionNo2')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("RequisitionNo2")}}:</v-flex>
                    <v-flex d-flex xs8>{{wlReg.Registration.RequisitionNo2}}</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md6>
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("ScanXRegNo")}}:</v-flex>
                    <v-flex d-flex xs8>{{wlReg.Registration.ScanXRegNo}}</v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Weight")}}:</v-flex>
                    <v-flex d-flex xs8>{{getWeightStr(wlReg)}}</v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("DateFirst")}}:</v-flex>
                    <v-flex d-flex xs8>{{getDate(wlReg.Registration.DateFirst)}}</v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("RegistrationNo")}}:</v-flex>
                    <v-flex d-flex xs8>{{wlReg.Registration.No}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Plant')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Plant")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{wlReg.Registration.PlantNo}} - {{wlReg.Registration.PlantName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Facility')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Facility")}}:</v-flex>
                    <v-flex d-flex xs8>{{wlReg.Registration.Facility}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Comment')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Comment")}}:</v-flex>
                    <v-flex d-flex xs8>{{wlReg.Registration.Comment1}}</v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
                <v-card-actions style="padding: 0px 0px 0px 0px" v-if="wlReg.FinishedBy != null || wlReg.Registration.Completed">
                  <v-flex xs3>
                    <div class="red--text" style="padding: 0px 0px 0px 10px">{{getMessage(wlReg)}}</div>
                  </v-flex>
                  <v-flex xs3>
                    <v-btn class="mr-1 mb-1" @click="completeRegistration(wlReg)" color="white" :hidden="!getMessage(wlReg)">
                      {{$t("Ok")}}
                    </v-btn>
                  </v-flex>
                  <v-flex xs6 text-right>
                    <v-btn class="mr-1 mb-1" @click="printRegistrationMobile(wlReg.Id)" color="primary" :disabled="localZplPrint && (!wlReg.Registration.Completed || wlReg.Registration.ScanXRegNo == 0)">
                      {{$t("Print Mobile")}}
                    </v-btn>
                    <v-btn class="mr-1 mb-1" @click="printRegistration(wlReg.Id)" color="primary" :disabled="!wlReg.Registration.Completed || wlReg.Registration.ScanXRegNo == 0">
                      {{$t("Print")}}
                    </v-btn>
                  </v-flex>
              </v-card-actions>
            </v-card>
          </div>

        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog
      v-model="confirmZeroKgDialog" max-width="350">
      <v-card>
        <v-card-title class="headline">{{$t("NoWeightAdded")}}</v-card-title>
        <v-card-text>{{$t("NoWeightDescription")}}</v-card-text>
        <v-card-text>{{$t("WeightNet")}}: {{ finishWeightChecked }} kg</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="confirmZeroKgDialog = false">{{$t("Ok")}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import { app } from '@/main'
import filters from '@/core/mixins/common-filters'
import * as DateUtil from '@/core/date'
import * as WheelLoader from '@/modules/wheel-loader/wheel-loader'
import * as Archive from '@/core/archive'
import * as LocalStorage from '@/core/local-storage'
import * as Security from '@/core/security'
import _ from 'lodash' // clone
import { UserDetail } from '@/core/userDetail'
import ct from '@/core/mixins/common-translations'

export default {
  // mixins: [filters],
  mixins: [ct, filters],
  name: 'registrations',
  data () {
    return {
      loading: true,
      registrations: null,
      loadRegistrationsIntervalId: null,
      facilityNo: null,
      facilities: [],
      facilitiesDescription: [],
      facilityDescription: '',
      useFacilityDescription: false,
      facilityDisplay: '',
      facilitiesDisplay: [],
      plantName: null,
      plants: [],
      wheelLoaderDisableButtons: false,
      hiddenFields: [],
      pendingVehicles: [],
      localPrint: false,
      localZplPrint: false,
      printTitle: '',
      zplPrinterIp: '',
      zplPrinterWidth: null,
      printerNo: '',
      printerIp: '',
      printers: [],
      playSound: false,
      confirmZeroKgDialog: false,
      finishWeightChecked: 0,
      VehicleNameDisplay: false
    }
  },
  watch: {
  },
  methods: {
    soundOnce () {
      this.sound()
      this.$root.$message.showSuccess(this.$t('Sound on'))
    },
    sound () {
      // Play a sound also on iPad needs user one invoke to work, by clicking on the bell icon
      // double call is a workaround due to iPad fail when play once - sounds like one sound
      this.$refs.regSound.currentTime = 0
      this.$refs.regSound.play()
      this.$refs.regSound.currentTime = 0
      this.$refs.regSound.play()
    },
    printRegistration (regId) {
      WheelLoader.printRegistration(regId)
      this.$root.$message.showSuccess(this.$t('Confirmation printed'))
    },
    printRegistrationMobile (regId) {
      var regs = this.registrations.filter(r => r.Id === regId)
      if (regs.length > 0) {
        this.$router.push({ name: 'print-wheel-loader-zpl', params: { id: regId, header: this.printTitle, zplPrinterIp: this.printerIp, zplPrinterWidth: this.zplPrinterWidth } })
      }
    },
    async printerChanged () {
      this.printerIp = this.printers.find(p => p.no === this.printerNo).ip
      if (this.printerIp != null) LocalStorage.save('printerIp', this.printerIp)
    },
    getHeaderValue (item, header) {
      let result = ''
      if (!Object.prototype.hasOwnProperty.call(header, 'Source') || (header.Source === 'WeightRegistration' || header.Source == null)) {
        result = item.WeightRegistration[header.Field]
      } else {
        if (header.Source === 'WheelLoaderRegistration') {
          result = item[header.Field]
        }
      }
      if (header.AsDate) result = DateUtil.getDateTime(result)
      return result
    },
    getHeaderStyle (header) {
      let result = ''
      if (Object.prototype.hasOwnProperty.call(header, 'Style')) {
        result = header.Style
      }
      return result
    },
    async plantChanged () {
      if (this.plantName != null) LocalStorage.save('plantName', this.plantName)
      this.registrations = null

      // Re-Load registrations
      const res = await WheelLoader.loadRegistrations(this.facilityNo)
      if (!res.failed) this.registrations = res.data
      // Filter registrations on plantName - if any
      if (this.plantName && this.registrations) this.registrations = this.registrations.filter(r => r.Registration.PlantName === this.plantName)
      // Load unique pending Vehicles for New button parameter
      this.pendingVehicles = [...new Set(this.registrations.filter(r => !r.Registration.Completed).map(p => p.Registration.VehicleNo))]
    },
    async loadFacilityDetails () {
      const res = await WheelLoader.loadFacilityData({ facilityNo: this.facilityNo, corpName: Security.user.corporation })
      if (!res.failed) {
        if (res.data != null) {
          this.details = res.data.Details
          const printerDetail = this.details.find(o => o.Name === 'localPrinterWl')
          if (printerDetail !== undefined) {
            this.localPrint = (printerDetail.Value === 'true')
          }
          const printerZplDetail = this.details.find(o => o.Name === 'localZplPrinterWl')
          if (printerZplDetail !== undefined) {
            this.localZplPrint = (printerZplDetail.Value === 'true')
          }
          const printTitleDetail = this.details.find(o => o.Name === 'printTitleWl')
          if (printTitleDetail !== undefined) {
            this.printTitle = printTitleDetail.Value
          }
        }
      }
    },
    async facilityChanged () {
      if (this.useFacilityDescription) {
        var facilityDisplay = this.facilitiesDisplay.find(f => f.value === this.facilityDisplay)
        if (facilityDisplay != null) {
          this.facilityNo = facilityDisplay.item.No
        }
      } else {
        this.facilityNo = this.facilityDisplay
      }

      if (this.facilityNo != null) LocalStorage.save('facilityNo', this.facilityNo)

      // Re-Load Plants
      const plantsRes = await Archive.loadPlants(this.facilityNo)
      if (!plantsRes.failed) {
        // Let user select no plants (= show data from all allowed plants)
        if (!plantsRes.data.includes('')) plantsRes.data.unshift({ No: '', Name: '' })
        this.plants = plantsRes.data.map(item => {
          return {
            text: item.Name,
            value: item.Name,
            item: item
          }
        })
      }
      // Set this.plantName
      if (this.plants.some(e => e.item.Name === this.plantName)) {
        // this.plantName is OK
      } else {
        this.plantName = null
        LocalStorage.remove('plantName')
      }

      await this.loadFacilityDetails()

      this.registrations = null
      // Re-Load registrations
      const res = await WheelLoader.loadRegistrations(this.facilityNo)
      if (!res.failed) this.registrations = res.data
      // Filter registrations on plantName - if any
      if (this.plantName && this.registrations) this.registrations = this.registrations.filter(r => r.Registration.PlantName === this.plantName)
      // Load unique pending Vehicles for New button parameter
      this.pendingVehicles = [...new Set(this.registrations.filter(r => !r.Registration.Completed).map(p => p.Registration.VehicleNo))]
    },
    async updateUi () {
    },
    getColor: function (wlReg) {
      if (wlReg.FinishedBy != null || wlReg.Registration.Completed) return 'rgba(210, 210, 210)'
      return 'rgba(255,255,255)'
    },
    getDate (date) {
      return DateUtil.getDateTime(date)
    },
    getRealDate (date) {
      const res = DateUtil.getRealDate(date)
      return res
    },
    getCustomerStr (wlReg) {
      if (wlReg.Registration.CustomerNo && wlReg.Registration.CustomerName) { return wlReg.Registration.CustomerNo + ' - ' + wlReg.Registration.CustomerName } else if (wlReg.Registration.CustomerNo) { return wlReg.Registration.CustomerNo } else if (wlReg.Registration.CustomerName) { return wlReg.Registration.CustomerName } else { return '' }
    },
    getWeightStr (wlReg) {
      if (wlReg && wlReg.CreatedBy.startsWith('corp:')) {
        // Weighing is via weightbridge
        if (wlReg.Registration.Completed) {
          return wlReg.Registration.WeightNet + ' kg'
        } else {
          return wlReg.Registration.WeightFirst + ' kg (' + this.$t('WeightFirst') + ')' // Vehicle has only done a first weighing
        }
      } else {
        // Weighing is via wheelloader
        return Math.abs(wlReg.Registration.WeightFirst - wlReg.Registration.WeightSecond) + ' kg'
      }
    },
    getFinishWeight (wlReg) {
      // Same logic as getWeightStr, but returns the raw numeric value
      if (wlReg && wlReg.CreatedBy.startsWith('corp:')) {
        return wlReg.Registration.Completed
          ? wlReg.Registration.WeightNet
          : wlReg.Registration.WeightFirst
      } else {
        return Math.abs(wlReg.Registration.WeightFirst - wlReg.Registration.WeightSecond)
      }
    },
    onFinishClick (wlReg) {
      const weight = this.getFinishWeight(wlReg)
      if (weight <= 0) {
        this.finishWeightChecked = weight
        this.confirmZeroKgDialog = true
        return
      }
      // Weight is positive - proceed to Finish view
      this.$router.push({ name: 'finish-wheel-loader-registration', params: { id: wlReg.Id } })
    },
    getMessage (wlReg) {
      if (wlReg) {
        if (wlReg.Registration.Cancelled) {
          return this.$t('Cancelled')
        } else if (!wlReg.Registration.Completed) {
          if (!wlReg.Registration.DateFirst) {
            return this.$t('No registration')
          } else {
            return this.$t('Not checked out')
          }
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    isHide (fieldName) {
      return this.hiddenFields.some(h => h === fieldName)
    },
    async completeRegistration (wlReg) {
      wlReg.Registration.Completed = true
      const res = await WheelLoader.saveRegistration({
        Id: wlReg.id,
        RegistrationId: wlReg.registrationId,
        Facility: this.facilityNo,
        FinishedDate: new Date(),
        FinishedBy: wlReg.finishedBy,
        Comment: wlReg.comment,
        Registration: wlReg.Registration
      })
      if (res.failed) {
        this.$root.$message.showError(this.$t('Registration not marked completed'))
      }
    }
  },
  computed: {
    orderedRegistrations: function () {
      var self = this // Need this to refence this.newestFirst inside compare function.
      var sortComparer = function (a, b) {
        // if a is less than b, return -1
        // if a is greater than b, return 1
        // if a is equal to b, return 0
        var aDate = new Date(a.CreatedDate)
        var bDate = new Date(b.CreatedDate)
        /* if(self.newestFirst)
          return bDate - aDate;
        else */
        return aDate - bDate
      }

      if (self.registrations) {
        return self.registrations.sort(sortComparer)
      } else {
        return []
      }
    },
    orderedRegistrationsReverse: function () {
      return this.orderedRegistrations.slice().reverse()
    }
  },
  beforeDestroy () {
    // Stop update of registration list
    clearInterval(this.loadRegistrationsIntervalId)
  },
  async mounted () {
    var noValue = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === undefined ?? false
    if (noValue) {
      this.useFacilityDescription = false
    } else {
      this.useFacilityDescription = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === 'true' ?? false
    }
    // Update registration list every 5 seconds

    this.loadRegistrationsIntervalId = setInterval(async () => {
      // Re-Load registrations
      const res = await WheelLoader.loadRegistrations(this.facilityNo)
      if (!res.failed) {
        let currentRegs = ''
        let newRegs = ''
        for (const reg of this.registrations) {
          currentRegs = currentRegs + reg.Id
        }
        for (const reg of res.data) {
          newRegs = newRegs + reg.Id
        }

        // If more regs or if same amount, but not same regs
        if (newRegs.length > currentRegs.length || (currentRegs.length === newRegs.length && currentRegs !== newRegs)) {
          // Play a sound also on iPad
          this.sound()
        }

        this.registrations = res.data
      }
      // Filter registrations on plantName - if any
      if (this.plantName && this.registrations) this.registrations = this.registrations.filter(r => r.Registration.PlantName === this.plantName)
      // Load unique pending Vehicles for New button parameter
      this.pendingVehicles = [...new Set(this.registrations.filter(r => !r.Registration.Completed).map(p => p.Registration.VehicleNo))]
    }, 5000)

    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })

    // Use Settings from cached user's corporatationDetails
    if (Security.user.corporationDetails) {
      this.wheelLoaderDisableButtons = Security.user.corporationDetails.find(d => d.Name === 'WheelLoader_Disable_Buttons')?.Data1 === 'true' ?? false
      const defaultHidden = 'RequisitionNo2,Plant,Carrier,Comment' // New fields default hidden LSV/MITH. Remember to also add new defaults in Settings.vue and Registration.vue
      this.hiddenFields = (Security.user.corporationDetails.find(d => d.Name === 'WheelLoader_Fields_Hidden')?.Data1 ?? defaultHidden).split(',')
      this.VehicleNameDisplay = Security.user.corporationDetails.find(d => d.Name === 'WheelLoader_Show_VehicleName')?.Data1 === 'true' ?? false
    }

    const zplPrinterIpUserDetail = await UserDetail.load(Security.user.id, 'ZplPrinterIpWl')
    if (zplPrinterIpUserDetail && zplPrinterIpUserDetail.Value) {
      this.zplPrinterIp = zplPrinterIpUserDetail.Value
      if (this.zplPrinterIp) {
        const rawPrinterIps = this.zplPrinterIp.split(',')
        rawPrinterIps.forEach(ip => {
          this.printers.push({ no: ip.split('.')[3], ip: ip })
        })
      }
    }

    const zplPrinterWidthUserDetail = await UserDetail.load(Security.user.id, 'ZplPrinterWidthWl')
    if (zplPrinterWidthUserDetail && zplPrinterWidthUserDetail.Value) this.zplPrinterWidth = zplPrinterWidthUserDetail.Value

    const storedPrinterIp = LocalStorage.load('printerIp')
    const printer = this.printers.find(p => p.ip === storedPrinterIp)
    if (printer && printer.no && printer.ip) {
      this.printerNo = printer.no
      this.printerIp = printer.ip
    } else {
      if (this.printers.length) {
        this.printerNo = this.printers[0].no
        this.printerIp = this.printers[0].ip
      } else LocalStorage.remove('printerIp')
    }
    // Load Facilities
    const facilitiesRes = await Archive.loadFacilities()
    const facilitiesResDescription = _.cloneDeep(facilitiesRes)
    if (!facilitiesRes.failed) {
      // Let user select no facilities (= show data from all allowed facilities)
      if (!facilitiesRes.data.includes('')) facilitiesRes.data.unshift({ No: '', Name: '' })
      this.facilities = facilitiesRes.data.map(item => {
        return {
          text: item.No,
          value: item.No,
          item: item
        }
      })
      this.facilitiesDisplay = this.facilities
      if (this.useFacilityDescription) {
      // const facilitiesRes2 = await Archive.loadFacilities()
        var d = facilitiesResDescription.data
        if (!d.includes('')) d.unshift({ No: '', Description: '' })
        this.facilitiesDescription = d.map(item => {
          return {
            text: item.Description,
            value: item.Description,
            item: item
          }
        })

        this.facilitiesDisplay = this.facilitiesDescription
      }
    }
    // Set old this.facilityNo from LocalStorage
    const storedFacilityNo = '' + LocalStorage.load('facilityNo')

    // Set old this.facilityNo from LocalStorage
    if (storedFacilityNo && this.facilities.some(e => e.item.No === storedFacilityNo)) this.facilityNo = storedFacilityNo
    else {
      this.facilityNo = null
      LocalStorage.remove('facilityNo')
    }
    if (this.useFacilityDescription) {
      if (this.facilityNo == null) { this.facilityNo = '' }
      this.facilityDisplay = this.facilitiesDescription.find(f => f.item.No === this.facilityNo).value
    } else {
      if (this.facilityNo == null) { this.facilityNo = '' }
      this.facilityDisplay = this.facilities.find(f => f.item.No === this.facilityNo).value
    }

    // Load Plants
    const plantsRes = await Archive.loadPlants(this.facilityNo)
    if (!plantsRes.failed) {
      // Let user select no plants (= show data from all allowed plants)
      if (!plantsRes.data.includes('')) plantsRes.data.unshift({ No: '', Name: '' })
      this.plants = plantsRes.data.map(item => {
        return {
          text: item.Name,
          value: item.Name,
          item: item
        }
      })
    }
    // Set old this.plantName from LocalStorage
    const storedPlantName = LocalStorage.load('plantName')
    if (storedPlantName && this.plants.some(e => e.item.Name === storedPlantName)) this.plantName = storedPlantName
    else {
      this.plantName = null
      LocalStorage.remove('plantName')
    }

    // Load registration list first time
    const res = await WheelLoader.loadRegistrations(this.facilityNo)
    await this.loadFacilityDetails()
    this.loading = false
    if (!res.failed) this.registrations = res.data
    // Filter registrations on plantName - if any
    if (this.plantName && this.registrations) this.registrations = this.registrations.filter(r => r.Registration.PlantName === this.plantName)
    // Load unique pending Vehicles for New button parameter
    this.pendingVehicles = [...new Set(this.registrations.filter(r => !r.Registration.Completed).map(p => p.Registration.VehicleNo))]

    // Always play sound on page load, if any registrations exists
    if (this.registrations.length > 0) this.sound()
  }
}
</script>

<style>

</style>
